import { render, staticRenderFns } from "./datatablePatente.vue?vue&type=template&id=86c29b74&"
import script from "./datatablePatente.vue?vue&type=script&lang=ts&"
export * from "./datatablePatente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports